import { isDevelopmentEnvironment } from "@/lib/env";

export let isOrderItemsReportEnabled = false;

// Relatório de Itens de Pedidos disponível em Desenvolvimento / Homologação.
isOrderItemsReportEnabled = isDevelopmentEnvironment;
